<script>
import Layout from "../../layouts/main.vue";
import Heading from "../../layouts/heading.vue";
import FormBuilder from "../../layouts/FormBuilder.vue";
import { schema } from "./data";
import api from "../../../api";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";

export default {
  props: {
    category: {},
  },
  components: {
    FormBuilder,
    Layout,
    Heading,
  },
  data() {
    return {
      page: schema,
      currentTopicActiveStatus: false,
      currentTopicActivationFailed: false,
      location_list: [],
      topics: [],
      topbar: {},
      selectedTab: "",
      selectedItem: {},
    };
  },
  methods: {
    create() {
      var val = this.page.tabs.filter((tab) => tab.name == this.selectedTab)[0]
        .formData;

      var data = {
        uuid: uuidv4(),
        url: this.currentPractice.additionalProp1.url,
        active: false,
        title: val.name,
        picture: "",
        excerpt: "Text here",
        description: "",
        deleted: false,
        creationDate: new Date().toISOString(),
        lastModifiedDate: new Date().toISOString(),
        categoryId: this.category.id,
        cmsId: this.currentCms.id,
        pcnId: this.currentPracticeData.pcnId,
        additionalProp1: {
          slug: "",
          color: "Red",
          further_details: {
            name: "Expand",
          },
          news_item_id: "",
          news_item_url: "",
          dynamoId: this.currentPractice.additionalProp1.dynamo,
        },
      };

      api.post("/api/categories/" + this.category.id + "/pages", data).then(
        (response) => {
          Swal.fire("Topic Added!", "Topic Added Successfully!", "success");
          this.page.tabs[0].side_panel.select_a_page.options.unshift(
            response.data
          );
          this.topbar.deleteBtn = true;
          this.topbar.activeBtn = true;
        },
        (error) => {
          console.log(error);
        }
      );
    },
    deleted() {
      var self = this;
      Swal.fire({
        title: `Are you sure you want to delete ${self.selectedItem.title}?`,
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          api.delete("/api/pages/" + this.selectedItem.id).then(
            () => {
              Swal.fire(
                "Topic Deleted!",
                "Topic Deleted Successfully!",
                "warning"
              );
              this.page.tabs[0].side_panel.select_a_page.options.splice(
                this.page.tabs[0].side_panel.select_a_page.options.findIndex(
                  function (i) {
                    return i.id === self.selectedItem.id;
                  }
                ),
                1
              );
              if (
                this.page.tabs[0].side_panel.select_a_page.options.length == 0
              ) {
                this.topbar.deleteBtn = false;
                this.topbar.activeBtn = false;
                this.$store.commit("updateOldFormData", new Object());
                this.$store.commit("updateCurrentFormData", new Object());
              }
            },
            (error) => {
              console.log(error);
            }
          );
        }
      });
    },
    submit(val) {
      if (this.selectedTab == "Alerts") {
        if (
          this.currentTopicActiveStatus &&
          this.topics.filter((x) => x.active).length > 0 &&
          this.topics.filter((x) => x.id != val.id && x.active).length != 0
        ) {
          Swal.fire(
            "Alert Already Active!",
            "Please in-active previous Alert and try again!",
            "error"
          );
        } else {
          var data = {
            title: val.title,
            description: val.description,
            active: this.currentTopicActiveStatus,
            additionalProp1: {
              // slug: val.path,
              color: val.color,
              further_details: val.further_details,
              news_item_id: val.news_item,
              news_item_url: val.external_link,
              dynamoId: this.currentPractice.additionalProp1.dynamo,
            },
          };

          api.patch("/api/pages/" + val.id, data).then(
            () => {
              this.page.tabs[0].side_panel.select_a_page.options.filter(
                (l) => l.id == val.id
              )[0].title = val.title;
              this.page.tabs[0].side_panel.select_a_page.options.filter(
                (l) => l.id == val.id
              )[0].description = val.description;
              this.page.tabs[0].side_panel.select_a_page.options.filter(
                (l) => l.id == val.id
              )[0].active = this.currentTopicActiveStatus;
              // this.page.tabs[0].side_panel.select_a_page.options.filter(l => l.id == val.id)[0].additionalProp1.slug = val.path;
              this.page.tabs[0].side_panel.select_a_page.options.filter(
                (l) => l.id == val.id
              )[0].additionalProp1.color = val.color;
              this.page.tabs[0].side_panel.select_a_page.options.filter(
                (l) => l.id == val.id
              )[0].additionalProp1.further_details = val.further_details;
              this.page.tabs[0].side_panel.select_a_page.options.filter(
                (l) => l.id == val.id
              )[0].additionalProp1.news_item_id = val.news_item;
              this.page.tabs[0].side_panel.select_a_page.options.filter(
                (l) => l.id == val.id
              )[0].additionalProp1.news_item_url = val.external_link
                ? val.external_link
                : "";
              Swal.fire(
                "Topic Updated!",
                "Topic Updated Successfully!",
                "success"
              );
            },
            (error) => {
              console.log(error);
            }
          );
        }
      }
    },
    activateToggle() {
      this.currentTopicActiveStatus = !this.currentTopicActiveStatus;
      if (
        this.currentTopicActiveStatus &&
        this.topics.filter((x) => x.active).length > 0 &&
        this.topics.filter((x) => x.id != this.selectedItem.id && x.active)
          .length != 0
      ) {
        this.currentTopicActiveStatus = !this.currentTopicActiveStatus;
        this.currentTopicActivationFailed = true;
        Swal.fire(
          "Alert Already Active!",
          "Please in-active previous Alert and try again!",
          "error"
        );
      } else {
        var data = {
          active: this.currentTopicActiveStatus,
        };
        api.patch("/api/pages/" + this.selectedItem.id, data).then(
          () => {
            let item =
              this.page.tabs[0].side_panel.select_a_page.options.filter(
                (l) => l.id == this.selectedItem.id
              )[0];
            item.active = this.currentTopicActiveStatus;
            this.page.tabs[0].side_panel.select_a_page.options.filter(
              (l) => l.id == this.selectedItem.id
            )[0] = item;
            this.$store.commit("updateOldFormData", item);
            this.$store.commit("updateCurrentFormData", item);
            Swal.fire(
              "Topic Status Updated!",
              "Topic Status Updated Successfully!",
              "success"
            );
          },
          (error) => {
            console.log(error);
          }
        );
      }
    },
    selectedItemFn(val) {
      this.selectedItem = val;
      this.currentTopicActiveStatus = val.active;
    },
    selectedTabFn(val) {
      this.selectedTab = val;
      this.topbar = this.page.tabs.filter((tab) => tab.name == val)[0];
    },
    getPages() {
      api
        .get("/api/categories/" + this.category.id + "/pages")
        .then((response) => {
          this.topics = response.data;
          this.page.tabs[0].side_panel.select_a_page.options =
            response.data.reverse();
          this.topbar = this.page.tabs[0];
          if (response.data.length == 0) {
            this.topbar.deleteBtn = false;
            this.topbar.activeBtn = false;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getNews() {
      api.get(`/api/cms/${this.currentCms.id}/categories`).then(
        (response) => {
          var newsCat = response.data.filter((x) => x.name == "News")[0];
          api.get(`/api/categories/${newsCat.id}/pages`).then(
            (response) => {
              // var news = response.data.map(function(item) {
              //   return item['title'];
              // });
              this.page.tabs.filter(
                (tab) => tab.name == "Alerts"
              )[0].form.news_item.options = response.data.filter(
                (x) => x.active == true
              );
            },
            (error) => {
              console.log(error);
            }
          );
        },
        (error) => {
          console.log(error);
        }
      );
    },
    currentTopicActivationFailedFn(val) {
      this.currentTopicActivationFailed = val;
    },
  },
  computed: {},
  watch: {},
  mounted() {
    this.getPages();
    this.getNews();
    // this.topbar = this.page.tabs[0];
  },
};
</script>

<template>
  <Layout>
    <Heading
      :page="topbar"
      :activeStatus="currentTopicActiveStatus"
      :activationStatus="currentTopicActivationFailed"
      @activateToggle="activateToggle"
      @created="create"
      @deleted="deleted"
      @form-submitted="submit"
      @activation-status="currentTopicActivationFailedFn"
    >
    </Heading>
    <FormBuilder
      :schema="page"
      :category="category"
      @selected-tab="selectedTabFn"
      @submit="submit"
      @selected-item="selectedItemFn"
    >
    </FormBuilder>
  </Layout>
</template>
